<div>
    <mat-checkbox color="{{color}}" (change)="onValueChange($event)" [ngModel]="ischecked">{{label}}</mat-checkbox>
</div>